module.exports = "<div class=\"personal__login-btn js-login\">ВОЙТИ</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./daily/assets/id/header/mobile/templates/notauthorized.tpl
// module id = 948
// module chunks = 11